import clsx from 'clsx'
import React, { forwardRef } from 'react'

import s from './styles.module.scss'

import { getTravelInputClassNameByEnum } from './location-picker.utils'
import { TravelInputModeEnum } from './travel-input-mode.enum'
import { Icon } from '../../../../atoms'

interface CrossButtonProps {
  onClick: () => void
}

const CrossButton = ({ onClick }: CrossButtonProps) => (
  <button onClick={onClick} className={s.crossButton}>
    <Icon name='cross-without-circle' color='black' width='7px' height='7px' />
  </button>
)

export interface InputProps {
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void
  onReset: () => void
  isMobile?: boolean
  mode?: TravelInputModeEnum
  revampEnabled?: boolean
  label?: string
}

export const Input = forwardRef<HTMLInputElement, InputProps>(
  (
    {
      onChange,
      onReset,
      isMobile,
      mode = TravelInputModeEnum.DEFAULT,
      revampEnabled = false,
      label,
    },
    ref,
  ) => {
    if (isMobile && revampEnabled && label) {
      return (
        <button
          className={clsx(
            s.houseSearch,
            s.inputRevampMobile,
            s.inputContainerMobile,
          )}
          onClick={onReset}
        >
          <div className={s.wrapper}>
            {label && <div className={s.label}>{label}</div>}
          </div>
        </button>
      )
    }

    // mode house search
    if (mode === TravelInputModeEnum.HOUSE_SEARCH || isMobile) {
      return (
        <div
          className={clsx(s[getTravelInputClassNameByEnum(mode)], {
            [s.inputContainerMobile]: isMobile,
            [s.inputContainerRevampMobile]: isMobile && revampEnabled,
          })}
        >
          <div className={isMobile ? s.wrapperMobile : s.wrapper}>
            <div className={s.mapPointerIcon}>
              <Icon name='map-pointer' size={20} color='#A9A9A9' />
            </div>
            <input
              className={isMobile ? s.inputMobile : s.input}
              onChange={onChange}
              ref={ref}
            />
          </div>
          <div>
            <CrossButton onClick={onReset} />
          </div>
        </div>
      )
    }

    // default
    return (
      <div
        className={clsx(s[getTravelInputClassNameByEnum(mode)], {
          [s.inputContainerMobile]: isMobile,
        })}
      >
        <div className={isMobile ? s.wrapperMobile : s.wrapper}>
          <div className={s.label}>Destination</div>
          <input
            className={isMobile ? s.inputMobile : s.input}
            onChange={onChange}
            ref={ref}
          />
        </div>
        <div>
          <CrossButton onClick={onReset} />
        </div>
      </div>
    )
  },
)
